import { render, staticRenderFns } from "./RaceTableFooter.vue?vue&type=template&id=f0e2a850&scoped=true"
import script from "./RaceTableFooter.vue?vue&type=script&lang=js"
export * from "./RaceTableFooter.vue?vue&type=script&lang=js"
import style0 from "./RaceTableFooter.vue?vue&type=style&index=0&id=f0e2a850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e2a850",
  null
  
)

export default component.exports